import {
  FORCE_PAGES_TO_KEEP_FOR_CHATBOT,
  PAGES_TO_EXCLUDE_FOR_CHATBOT,
  PAGES_TO_EXCLUDE_FOR_CHATBOT_ON_MOBILE_ONLY,
} from '@constants/chatbot';
import useI18n from '@hooks/i18n/useI18n';
import { useMediaQuery } from '@monofront/business/hooks';
import { isMobileApp } from '@utils/environment';
import { useRouter } from 'next/router';

const useChatbotEligibility = (): boolean => {
  const { isFrenchMarket } = useI18n();
  const router = useRouter();
  const isMobileWebsite = useMediaQuery(800);

  const hidePage =
    (!FORCE_PAGES_TO_KEEP_FOR_CHATBOT.includes(router.asPath) &&
      PAGES_TO_EXCLUDE_FOR_CHATBOT.includes(router.pathname)) ||
    PAGES_TO_EXCLUDE_FOR_CHATBOT.includes(router.asPath) ||
    (isMobileWebsite &&
      PAGES_TO_EXCLUDE_FOR_CHATBOT_ON_MOBILE_ONLY.includes(router.pathname));

  return isFrenchMarket && !isMobileApp && !hidePage;
};

export default useChatbotEligibility;
